import React from "react";
import { Modal } from "react-bootstrap";

const NewModal = (props) => {
  return (
    <Modal
      {...props}
      className="delete-popup"
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>Welcome! Is this your first time here?</h4>
        <div className="button-row">
          <button
            className="cancel-btn"
            onClick={() => {
              props.setNewModalOpen(false);
              window.location.reload();
            }}
          >
            No
          </button>
          <div
            onClick={() => {
              props.setNewModalOpen(false);
              props.setuserContextState((prevValue) => ({
                ...prevValue,
                runTour: true,
              }));
            }}
            className="button"
            style={{ cursor: "pointer" }}
          >
            Yes
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default NewModal;
